import { render, staticRenderFns } from "./EpoRoleInactiveModal.vue?vue&type=template&id=8bc70af4&scoped=true&"
import script from "./EpoRoleInactiveModal.vue?vue&type=script&lang=js&"
export * from "./EpoRoleInactiveModal.vue?vue&type=script&lang=js&"
import style0 from "./EpoRoleInactiveModal.vue?vue&type=style&index=0&id=8bc70af4&prod&lang=scss&"
import style1 from "./EpoRoleInactiveModal.vue?vue&type=style&index=1&id=8bc70af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc70af4",
  null
  
)

export default component.exports